import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useExceptionTypes = () => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["exception-types", tenantVal],
    queryFn: async () => {
      if (!tenantVal) return null;
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/schedule-exceptions/types`
      );
      return response.data;
    },
    enabled: !!tenantVal,
    meta: { errorMessage: "Error fetching exception types" },
  });
};
